var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Select", {
    attrs: {
      value: _vm.value,
      "allow-clear": "",
      "show-search": "",
      "option-filter-prop": "children",
      placeholder: _vm.$t("common.select-text", { text: _vm.$t("lbl_unit") }),
      "filter-option": _vm.useLocalFilter,
      disabled: _vm.disabled,
      options: _vm.options
    },
    on: { change: _vm.emits }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }